import { useAppSelector } from '../../../App/redux/store';
import { APIStatus } from '../../../services/axiosEnums';
import { getSubscriptionState } from '../subscriptionSlice';

export default function useSubscription() {
  const {
    subscription,
    subscriptionCities,
    subscriptionDepartments,
    subscriptionId,
    subscriptionIdIri,
  } = useAppSelector(getSubscriptionState);

  return {
    subscriptionIdIri,
    subscriptionId,
    subscription: subscription.result,
    subscriptionStatus: subscription.apiStatus,
    subscriptionStatusPending: subscription.apiStatus === APIStatus.PENDING,
    subscriptionError: subscription.error ?? null,
    subscriptionCities,
    subscriptionDepartments,
    totalAuthorizedUsers: subscription.result?.totalAuthorizedUsers ?? 0,
    subscriptionDemandExists: subscription.result
      ? Boolean(subscription.result?.subscriptionDemands.length)
      : false,
  };
}
